import { createJsonStorageRepo, removeStorageText } from '@runtime/shared/utils/storage'
import type { LauncherPreference } from './coachLauncherPosition'

export const COACH_LAUNCHER_POSITION_KEY = 'us_coach_launcher_position_v1'

function isLauncherPreference(value: unknown): value is LauncherPreference {
  if (!value || typeof value !== 'object') return false
  const preference = value as Partial<LauncherPreference>
  return (
    preference.version === 1 &&
    (preference.side === 'left' || preference.side === 'right') &&
    typeof preference.yRatio === 'number' &&
    Number.isFinite(preference.yRatio) &&
    preference.yRatio >= 0 &&
    preference.yRatio <= 1
  )
}

export const coachLauncherPreferences = {
  ...createJsonStorageRepo<LauncherPreference | null>(
    COACH_LAUNCHER_POSITION_KEY,
    null,
    isLauncherPreference,
  ),
  clear: () => removeStorageText(COACH_LAUNCHER_POSITION_KEY),
}
